import React from 'react';
import { HeroSection } from '../components/SalesLetter/HeroSection';
import { OpeningHook } from '../components/SalesLetter/OpeningHook';
import { PainAmplification } from '../components/SalesLetter/PainAmplification';
import { DreamSection } from '../components/SalesLetter/DreamSection';
import { OldMethodsFail } from '../components/SalesLetter/OldMethodsFail';
import { MechanismReveal } from '../components/SalesLetter/MechanismReveal';
import { ProductPresentation } from '../components/SalesLetter/ProductPresentation';
import { HacksExplained } from '../components/SalesLetter/HacksExplained';
import { CredibilitySection } from '../components/SalesLetter/CredibilitySection';
import { OfferSection } from '../components/SalesLetter/OfferSection';
import { GuaranteeSection } from '../components/SalesLetter/GuaranteeSection';
import { UrgencySection } from '../components/SalesLetter/UrgencySection';
import { FinalCTA } from '../components/SalesLetter/FinalCTA';
import { FAQSection } from '../components/SalesLetter/FAQSection';
import { Footer } from '../components/SalesLetter/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-navy-dark selection:bg-gold-primary/30 selection:text-white" data-id="element-352">
      <HeroSection data-id="element-353" />
      <OpeningHook data-id="element-354" />
      <PainAmplification data-id="element-355" />
      <DreamSection data-id="element-356" />
      <OldMethodsFail data-id="element-357" />
      <MechanismReveal data-id="element-358" />
      <ProductPresentation data-id="element-359" />
      <HacksExplained data-id="element-360" />
      <CredibilitySection data-id="element-361" />
      <OfferSection data-id="element-362" />
      <GuaranteeSection data-id="element-363" />
      <UrgencySection data-id="element-364" />
      <FinalCTA data-id="element-365" />
      <FAQSection data-id="element-366" />
      <Footer data-id="element-367" />
    </main>;
}